export enum CheckBoxColor {
  BLUE = "blue",
  GREEN = "green",
  ORANGE = "orange",
  GREY = "grey"
}
